module.exports = __webpack_public_path__ + "static/img/title_02@2x.fefd04e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/title_02@2x.png
// module id = KHuD
// module chunks = 1